module.exports = new __parcel__URL__("joinEventPng.33507170.png").toString();